import apiClient from './api-client';

const toNumber = value => Number(value) || 0;

const normalizeCoupon = coupon =>
  coupon
    ? {
        brandName: coupon.brandName || '',
        logoUrl: coupon.logoUrl || null,
        offerText: coupon.offerText || '',
        offerSubtitle: coupon.offerSubtitle || null,
      }
    : null;

// GET user/rewards. Resolves to the normalised rewards data, throws on failure.
export const getRewards = async () => {
  const response = await apiClient.get('user/rewards');
  const body = response.data || {};
  const success = body.Success ?? body.success ?? body.status;
  const data = body.Data || body.data;
  if (!data || success === 0 || success === false) {
    throw new Error(body.Message || body.message || 'Could not load rewards');
  }

  const active = data.activeTarget;
  return {
    scans: {
      approved: toNumber(data.scans?.approved),
      pending: toNumber(data.scans?.pending),
      rejected: toNumber(data.scans?.rejected),
    },
    activeTarget: active
      ? {
          level: toNumber(active.level),
          tierName: active.tierName || '',
          scansRequired: toNumber(active.scansRequired),
          scansDone: toNumber(active.scansDone),
          scansRemaining: toNumber(active.scansRemaining),
          coupon: normalizeCoupon(active.coupon),
        }
      : null,
    targets: (Array.isArray(data.targets) ? data.targets : [])
      .map(target => ({
        level: toNumber(target.level),
        tierName: target.tierName || '',
        scansRequired: toNumber(target.scansRequired),
        previousScansRequired: toNumber(target.previousScansRequired),
        state: target.state || 'locked',
        coupon: normalizeCoupon(target.coupon),
        reward: target.reward || null,
      }))
      .sort((a, b) => a.level - b.level),
    claimedRewards: Array.isArray(data.claimedRewards) ? data.claimedRewards : [],
    allTiersCompleted: !!data.allTiersCompleted,
    hasActivePackage: !!data.hasActivePackage,
  };
};
